module.exports = __webpack_public_path__ + "static/img/icon_wn.9b3e4b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_wn.png
// module id = anOj
// module chunks = 0